module.exports = __webpack_public_path__ + "img/salesnav-logo.7fa7889a.png";